import { ApiClient } from 'app/service/api-service'
import { DashboardEndPoint } from './constant'
import { IParamsFilterDashboard } from './model'

export const requestGetDashboardInfo = (params: IParamsFilterDashboard) =>
  ApiClient.Get({
    url: DashboardEndPoint.GET_DASHBOARD_ADMIN,
    params: { params },
  })
